import { useEffect } from "react";
import axios from "@/axios";

export type ErrorObject = {
    errorKey: string;
    message: string | Event;
    source?: string;
    lineno?: number;
    colno?: number;
    error?: Error;
}

export const logError = async (errObject: ErrorObject) => {
    const error = { ...errObject, frontend: true };
    axios.post("/api/logger", {
        message: JSON.stringify(error),
    }).catch(() => { });
};

export const useGlobalErrorHandler = () => {
    const errorMap: Map<string, Date> = new Map();

    const expirationTime = 10 * 1000 // 10 seconds

    const pushError = (errObject: ErrorObject) => {
        const expirationDate = new Date();
        expirationDate.setMilliseconds(expirationDate.getMilliseconds() + expirationTime);
        errorMap.set(errObject.errorKey, expirationDate);
        logError(errObject);
    }

    const errorExists = (key: string) => {
        const expirationDate = errorMap.get(key);
        if (!expirationDate) return false;
        const currentDate = new Date();
        return expirationDate > currentDate;
    }

    const getKey = (errObject: Omit<ErrorObject, "errorKey">): string => {
        return `${errObject.message}-${errObject.source}-${errObject.lineno}-${errObject.colno}`;
    }

    useEffect(() => {
        window.onerror = (message, source, lineno, colno, error) => {
            const errorObject: Omit<ErrorObject, "errorKey"> = { message, source, lineno, colno, error };
            const errorKey = getKey(errorObject);
            const errorAlreadyThrown = errorExists(errorKey);
            if (errorAlreadyThrown) return;
            pushError({ ...errorObject, errorKey });
        };
    }, []);
};